import { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";

export const DELIVERY_MESSAGES = [
    "Order delivered to mailbox.",
    "Order delivered to front porch.",
] as const;

type Props = {
    open: boolean;
    loading?: boolean;
    onClose: () => void;
    onConfirm: (deliveryMessage: string | null) => void;
};

export default function MarkDeliveredDialog({ open, loading, onClose, onConfirm }: Props) {
    const [choice, setChoice] = useState<string>("");

    useEffect(() => {
        if (open) setChoice("");
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Mark delivered</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    Optionally include a note in the customer's delivery email.
                </Typography>
                <RadioGroup value={choice} onChange={(e) => setChoice(e.target.value)}>
                    <FormControlLabel value="" control={<Radio size="small" />} label="No message" />
                    {DELIVERY_MESSAGES.map((m) => (
                        <FormControlLabel key={m} value={m} control={<Radio size="small" />} label={m} />
                    ))}
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button
                    variant="contained"
                    disabled={loading}
                    onClick={() => onConfirm(choice || null)}
                >
                    {loading ? "Marking…" : "Mark delivered"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
